<template>
    <v-container>
        <h2 class="gradation">音と画で知るセキュリテ</h2>

        <v-window v-model="toggle_media" :touch="{left: null, right: null}">

            <v-window-item value="video">
                <VideoList></VideoList>
            </v-window-item>

        </v-window>

    </v-container>
</template>

<script>
import VideoList from '../components/VideoList'

export default {
    name: 'TabMedia',
    components: {
        VideoList
    },
    data: () => ({
        tab_id: 'video',
        condition: ''
    }),
    computed: {
        toggle_media: {
            get(){
                return this.tab_id
            },
            set(newVal){
                if( newVal == null ){
                    return
                }
                this.tab_id = newVal
            }
        }
    },
    async mounted() {
    },
    methods: {
    }
}
</script>